<template>
    <div class="block p-2 my-3 whitespace-normal bg-gray-100 rounded-lg dark:bg-gray-900">
        <slot />
    </div>
</template>
